import { render, staticRenderFns } from "./company_seal_item_dialog.vue?vue&type=template&id=55ac81d8&scoped=true"
import script from "./company_seal_item_dialog.vue?vue&type=script&lang=js"
export * from "./company_seal_item_dialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55ac81d8",
  null
  
)

export default component.exports